export default __webpack_public_path__ + "static/media/mobile-interface-porfolio.d86d763e.svg";